<template>
    <div class="layout" :style="`background-color:${bgc};`">
        <Header></Header>
        <NavBar></NavBar>
        <slot name="header"></slot>
        <!--<div class="layout_content">-->
            <slot>
            </slot>
        <!--</div>-->
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from './Header'
    import NavBar from './NavBar'
    import Footer from './Footer'
    export default{
        name: 'Layout',
        components: { Header, NavBar, Footer},
        props: {
            bgc:{
                type: String
            },
        },
        computed: {

        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue